module.exports = __webpack_public_path__ + "img/tixingttest.72503099.svg";